export const MeiliIndexes = {
  member: 'member',
  allergen: 'allergen',
  category: 'category',
  contentElement: 'content-element',
  element: 'element',
  gastroCategory: 'gastro-category',
  gastroFood: 'gastro-food',
  gastroMenu: 'gastro-menu',
  homeTeaser: 'home-teaser',
  industry: 'industry',
  menu: 'menu',
  menuPage: 'menu-page',
  plan: 'plan',
  product: 'product',
  regionEvent: 'region-event',
  regionImage: 'region-image',
  regionJob: 'region-job',
  regionNews: 'region-news',
  regionPost: 'region-post',
  regionService: 'region-service',
  shippingRate: 'shipping-rate',
  siteConfig: 'site-config',
  teaser: 'teaser',
  teaserElement: 'teaser-element',
  vendor: 'vendor',
  page: 'page',
  taxRate: 'tax-rate'
};
